import type { ReactNode } from 'react'
import type { CustomCellRendererProps } from 'ag-grid-react'
import { useNavigate } from 'react-router-dom'
import Tooltip from 'antd/es/tooltip'
import IdeyaTypography from '@/common/antd/ideya-typography'
import { useAppSelector } from '@/redux/hooks.ts'
import {
  selectTheme,
  selectThemeStyle,
} from '@/features/setting/setting.slice.ts'
import { Theme } from '@/features/setting/setting.def'
// import theme from 'antd/es/theme'

export interface TickerCodeCellRendererParams {
  tooltipTitle: ReactNode
  navigateTo: string
  getNavigationState?: (params: CustomCellRendererProps) => unknown
  onBeforeNavigate?: (params: CustomCellRendererProps) => void
  isNavigationDisabled?: (params: CustomCellRendererProps) => boolean
  hasAccess?: boolean
}

type TickerCodeCellRendererProps = CustomCellRendererProps &
  TickerCodeCellRendererParams

export const TickerCodeCellRenderer = (params: TickerCodeCellRendererProps) => {
  const themeStyle = useAppSelector(selectThemeStyle)
  const navigate = useNavigate()
  const tickerCode = params.value
  // const { token } = theme.useToken()
  const colorTheme = useAppSelector(selectTheme)
  const handleNavigate = () => {
    params.onBeforeNavigate?.(params)
    navigate(params.navigateTo, {
      state: params.getNavigationState?.(params),
    })
  }

  if (!params.data || !tickerCode) return null

  if (params.isNavigationDisabled?.(params)) {
    return (
      <IdeyaTypography.Text style={{ color: themeStyle.disabledBookName }}>
        {tickerCode}
      </IdeyaTypography.Text>
    )
  }

  if (params.hasAccess === false) {
    return <IdeyaTypography.Text>{tickerCode}</IdeyaTypography.Text>
  }

  return (
    <Tooltip
      title={params.tooltipTitle}
      placement={'rightBottom'}
      color={colorTheme === Theme.Light ? 'white' : ''}
      styles={{
        body: {
          color: colorTheme === Theme.Light ? themeStyle.colorText : '',
        },
      }}
    >
      <span
        role={'link'}
        tabIndex={0}
        onClick={(event) => {
          event.stopPropagation()
          handleNavigate()
        }}
        onKeyDown={(event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault()
            event.stopPropagation()
            handleNavigate()
          }
        }}
        style={{
          color: themeStyle.bookNameLink,
          textDecoration: 'underline',
          cursor: 'pointer',
        }}
      >
        {tickerCode}
      </span>
    </Tooltip>
  )
}
